// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lLbm","label":"styles_label__3JK80"};